export const getInitialSpeedThreadValues = date => ({
  type: 'MENTION',
  status: 'draft',
  startDate: date,
  endDate: date,
  actions: [
    {
      failure: [],
      success: [
        {
          type: 'Start Speed Thread',
          sendStartReply: true
        }
      ],
      platform: 'twitter',
      triggers: [
        {
          type: 'Like',
          action: 'NEW_TWEET',
          RetweetUrl: ''
        }
      ],
      description: 'Start User Journey',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Add Timed Thread Activity'
        }
      ],
      platform: 'twitter',
      triggers: [
        {
          type: 'Like Of Any',
          value: []
        }
      ],
      description: 'Count User Interactions',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Send Tweet'
        }
      ],
      platform: 'twitter',
      triggers: [
        {
          type: 'Speed Thread Expired'
        }
      ],
      description: 'Stop Timer and Notify User',
      operator: 'all'
    }
  ],
  moderated: false,
  moderators: { handles: [] },
  automated: false,
  threshold: 20,
  enableFiltering: true,
  enableBlastFiltering: true,
  store: false,
  profanity: false,
  lock: false,
  scoreboardConfig: {
    adsAccountId: '',
    cardId: '',
    framePublicId: '',
    slot: 0,
    pollIntervalMs: 0,
    textFont: '',
    textColor: '',
    textSize: '',
    textGravity: '',
    textX: '',
    textY: ''
  }
})



// WEBPACK FOOTER //
// ./src/pages/widgets/twitter_speed_thread/create/container/initialValues.js